import { useEffect, useState } from "react";
import { useFonts, useWindowSize } from "hooks";

const useCoordinates = ({ containerSelector, elSelector }: { containerSelector: string; elSelector: string }) => {
  const [coord, setCoord] = useState({
    x: 0,
    y: 0,
  });
  const [elWidth, setElementWidth] = useState(0);
  const [elHeight, setElementHeight] = useState(0);
  const { fontsIsLoaded } = useFonts();

  const { width: windowWidth } = useWindowSize();

  useEffect(() => {
    const insideImage = document.querySelector(elSelector);
    const textContainer = document.querySelector(containerSelector);

    if (!insideImage || !textContainer) return;

    const { x: insideImageX, y: insideImageY } = insideImage.getBoundingClientRect();
    const { x: textContainerX, y: textContainerY } = textContainer.getBoundingClientRect();

    setElementWidth(insideImage.getBoundingClientRect().width);
    setElementHeight(insideImage.getBoundingClientRect().height);
    setCoord({
      x: insideImageX - textContainerX,
      y: insideImageY - textContainerY,
    });
  }, [windowWidth, elSelector, containerSelector, fontsIsLoaded]);

  return {
    x: coord.x,
    y: coord.y,
    elWidth,
    elHeight,
  };
};

export { useCoordinates };
